// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import memberForms from "./memberForms";
import "./load-more";
import carousel from "./carousel";
import "./portal-custom";

menuOpen();
memberForms();
carousel();
